
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Boards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boards"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visible"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_custom_bpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custom_bpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cached_default_bpi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"layers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LayerStub"},"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoardResult"},"directives":[]}]}}]}}],"loc":{"start":0,"end":283}};
    doc.loc.source = {"body":"#import \"./LayerStubFragment.graphql\"\n#import \"./BoardResultFragment.graphql\"\n\nfragment Boards on Project {\n  boards {\n    id\n    name\n    description\n    visible\n    use_custom_bpi\n    custom_bpi\n    cached_default_bpi\n    layers {\n      ...LayerStub\n    }\n    ...BoardResult\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./LayerStubFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./BoardResultFragment.graphql").definitions));


      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/BoardsFragment.graphql
// module id = dYg9
// module chunks = 1